import util from './util';
import _ from 'lodash';
import { ChargeType } from '@/models/transaction';
import { dateTimeFormat } from '@/constants/app';
import { getDistributionAmounts } from './transactionDistributionAmounts';
import type { RouteLocationRaw } from 'vue-router';

const formatTransactionData = (transaction: any) => {
  transaction.statusText =
    transaction.status === 'success' ? transaction.status : `${transaction.status} - ${_.startCase(transaction.errorCode)}`;
  transaction.userName = transaction.user ? util.getFullName(transaction.user.firstName, transaction.user.lastName) : '';
  transaction.role = transaction.user ? transaction.user.role.replace(/,/g, ', ') : '';

  if (transaction.distributions && transaction.category !== 2) {
    // ignore credits sale for split amount as customer and partner creidts/stripe
    Object.assign(transaction, getDistributionAmounts(transaction.distributions));
  }

  transaction.date = util.formatDateTime(new Date(transaction.date), dateTimeFormat);
  transaction.categoryText = ChargeType[transaction.category];
  transaction.textAmount = `$${transaction.amount}`;

  return transaction;
};

const getRefundFormRouteByTransaction = (transaction: any, query: any = {}): RouteLocationRaw | null => {
  if (transaction.category === ChargeType.Refund) {
    return null;
  }

  if (transaction.status === 'failed') {
    return null;
  }

  if (transaction.category === ChargeType.CreditSale) {
    return {
      path: 'refunds',
      hash: '#refund-gogo-credits',
    };
  }

  if (transaction.category === ChargeType.Ride) {
    if (transaction.description.startsWith('CustomCharge -')) {
      return {
        path: 'refunds',
        hash: '#refund-custom-charge',
        query: {
          ...query,
          transactionId: transaction.id,
        },
      };
    }

    return {
      path: 'Refunds',
      hash: '#refund-ride-costs',
      query: {
        ...query,
        requestId: transaction.associatedObjectId,
      },
    };
  }

  if (transaction.category === ChargeType.Membership) {
    return {
      name: 'Membership',
      hash: '#refund-subscription',
      query: {
        ...query,
        transactionId: transaction.id,
      },
    };
  }

  if (transaction.category === ChargeType.Food) {
    if (transaction.description.startsWith('Food:')) {
      return {
        name: 'DeliveryOrderHistory',
        hash: '#gourmet-history',
        query: {
          ...query,
          gourmetOrderId: transaction.description.replace('Food: ', ''),
        },
      };
    }

    return {
      path: 'Refunds',
      hash: '#refund-custom-charge',
      query: {
        ...query,
        transactionId: transaction.id,
      },
    };
  }

  return {
    path: 'Refunds',
    hash: '#refund-custom-charge',
    query: {
      ...query,
      transactionId: transaction.id,
    },
  };
};

export default {
  formatTransactionData,
  getRefundFormRouteByTransaction,
};
